import { Box, Text, Flex, Heading, Icon, Tooltip } from '@chakra-ui/react';
import DescriptionHtml from 'components/molecules/DescriptionHtml';
import { useTranslation } from 'helpers/languages/translations';
import icons from 'shared/icons';
import { uploadedFileStyle } from 'shared/styles';
import useUploadSection from './ImageUploadContainer';

const ResultSection = ({ filesToUpload, uploadedData }: ReturnType<typeof useUploadSection>) => {
    const translate = useTranslation();

    return (
        <Box ml={5}>
            {filesToUpload.length === 0 && uploadedData.length > 0 ? (
                <Flex direction="column">
                    <Heading as="h2" fontWeight="semibold" fontSize="18px" mb="18px">
                        {translate('pictures.upload.results')}
                    </Heading>
                    <Box maxH={360} overflow="auto">
                        {uploadedData.map((d) => (
                            <Flex
                                {...uploadedFileStyle}
                                borderRadius="none"
                                alignItems="flex-end"
                                key={d.file.originalname || d.file.name}
                            >
                                <Icon as={icons.image} w={6} h={6} color="gray.700" />
                                <Text mx={3} verticalAlign="baseline">
                                    {d.file.originalname || d.file.name}
                                    {`${d.response.error ? `- ${d.response.error}` : ''}`}
                                </Text>
                                <Flex>
                                    {(d.file.hasNoProduct || d.file.wrongCompanyId) && (
                                        <Tooltip
                                            label={translate(
                                                d.file.hasNoProduct
                                                    ? 'pictures.upload.no_product'
                                                    : 'pictures.upload.wrong_company',
                                            )}
                                        >
                                            <Box>
                                                <Icon as={icons.warning} w={6} h={6} color="orange.400" />
                                            </Box>
                                        </Tooltip>
                                    )}
                                    {d.response.picture_id && <Icon as={icons.check} w={6} h={6} color="green.400" />}
                                    {d.response.error && <Icon as={icons.clear} w={6} h={6} color="red.400" />}
                                </Flex>
                            </Flex>
                        ))}
                    </Box>
                </Flex>
            ) : (
                <DescriptionHtml h="fit-content" tradKey="pictures.upload.description" />
            )}
        </Box>
    );
};

export default ResultSection;
